import {Component} from "@angular/core";
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralService } from 'src/app/shared/services/general.service';
import { HomeController } from '../../home.controller';
import { Document } from 'src/app/shared/models/document';
import { LoggerService } from 'src/app/core/logger/logger.service';
import { AbstractForm } from 'src/app/shared/utils/abstract-form';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';

@Component({
    selector: 'home-advertise',
    templateUrl: './advertise.form.component.html',
    styleUrls: ['./advertise.form.component.scss']
})
export class AdvertiseFormComponent extends AbstractForm{

    msg = '';

    constructor(
        protected formBuilder: FormBuilder,
        logger: LoggerService,
        private httpService: HttpService,
        private control: HomeController, 
        public gs: GeneralService
        ) {
            super(formBuilder, logger);
            control.init();
         }

    buildFormGroup(): FormGroup {
        return this.formBuilder.group({
            //businessName: ['', [Validators.required, Validators.minLength(3)]],
            document: ['', [Validators.required, Document.validate('cnpj')]],
            //city: ['', [Validators.required, Validators.minLength(3)]],
            name: ['', [Validators.required, Validators.minLength(3)]],
            email: ['', [Validators.required, Validators.email]],
            cellphone: ['', [Validators.required, Validators.minLength(10)]],
            source : ['site'],
            source_action : ['quero anunciar']
            //num_ads: ['', [Validators.required, Validators.minLength(1)]],
        });
    }
 
    updateControls() {}
    updateObject(): any {
        return {
            //businessName: this.getControlValue('businessName'),
            document: this.getControlValue('document'),
            //city: this.getControlValue('city'),
            name: this.getControlValue('name'),
            email: this.getControlValue('email'),
            cellphone: this.getControlValue('cellphone'),
            source : 'site',
            source_action : 'quero anunciar',
            //num_ads: this.getControlValue('num_ads')
        }
    }  

    send(){
        let data = this.updateObject();
        this.httpService.post<any>(API.general.leadBuilder, data)
            .then(result => {
                this.msg = 'Obrigado, em breve o setor comercial entrará em contato';
                this.formGroup.reset();
            })
            .catch((err) =>{ this.gs.error(err); })
            .finally(() => {
//                this.signUpSubmit = false;
            });
    }


    phoneMethod(event,field){
        switch(event.type){
          case 'focus':
            if(!this.getControlValue(field))
              this.setControlValue(field,'55');
          break;
          case 'blur':
            if(this.getControlValue(field) == '55')
              this.setControlValue(field,null);
          break;
        }
      }

}